<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams" [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"
[canAdd]="canAdd" [addNewRowFn]="addRow.bind(this)" [addLineModel]="bottomToolbar.addLine"

>
    <ng-container topToolbar>
      <app-toolbar [toolbar]="topToolbar">
          <ng-template 
            toolbarToolDef="delete_selected_rows" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_delete_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
      </app-toolbar>
  </ng-container>


  <ng-container gridColumnDef="name">

    <ng-template gridCellDisplayControlDef let-row>
    <Notifications-auto_email_report_options_dd_single 
        data-cy="selector"
        [type]="row.cells.name.displayControl.type"
        [formControl]="row.formGroup.controls['name_display']"
        (displayTextChange)="row.cells.name.displayControl.displayText=$event"
        [placeholder]="row.cells.name.displayControl.placeholder"
        [styles]="row.cells.name.displayControl.styles"
        [tooltip]="row.cells.name.displayControl.tooltip"
      [ruleContext]="row.$fields_name_selector_inParams_ruleContext"
      [excludeReports]="row.$fields_name_selector_inParams_excludeReports"
    >
    </Notifications-auto_email_report_options_dd_single>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Notifications-auto_email_report_options_dd_single 
        data-cy="selector"
        [type]="row.cells.name.editControl.type"
        [formControl]="row.formGroup.controls['name_edit']"
        (displayTextChange)="row.cells.name.editControl.displayText=$event"
        [placeholder]="row.cells.name.editControl.placeholder"
        [styles]="row.cells.name.editControl.styles"
        [tooltip]="row.cells.name.editControl.tooltip"
      [ruleContext]="row.$fields_name_selector_inParams_ruleContext"
      [excludeReports]="row.$fields_name_selector_inParams_excludeReports"
    >
    </Notifications-auto_email_report_options_dd_single>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
